import React from "react";
import RoutingContents from "./RoutingContents";
import GlobalComponentManager from "./GlobalComponentManager";

import TagManager from "react-gtm-module";
import { useScrollTopRefresher } from "src/hooks/useScrollTopRefresher";
export default function GoonoRoutingManager() {
  React.useEffect(() => {
    // google tag manager initialize
    TagManager.initialize({ gtmId: "GTM-PGR3HZMK" });
  }, []);

  return (
    <React.Fragment>
      <GlobalComponentManager />
      <RoutingContents />
      {useScrollTopRefresher()}
    </React.Fragment>
  );
}
